export const formatPhoneNumber = (value) => {
    // Remove all non-digit characters except +
    const cleaned = value.replace(/[^\d+]/g, "");

    // If empty or just starting to type
    if (!cleaned) return "";

    // Ensure it starts with +380
    if (!cleaned.startsWith("+380")) {
        if (cleaned.startsWith("+")) {
            return "+380";
        }
        if (cleaned.startsWith("380")) {
            return "+380";
        }
        return "+380";
    }

    // Limit to +380 + 9 digits = 13 characters total
    const limited = cleaned.slice(0, 13);

    // Format as +380 XX XXX XXXX
    let formatted = "+380";
    const digits = limited.slice(4); // Get digits after +380

    if (digits.length > 0) {
        formatted += " " + digits.slice(0, 2);
    }
    if (digits.length > 2) {
        formatted += " " + digits.slice(2, 5);
    }
    if (digits.length > 5) {
        formatted += " " + digits.slice(5, 9);
    }

    return formatted;
};

export const validatePhoneNumber = (phone) => {
    // Remove spaces and check if it's exactly +380 followed by 9 digits
    const cleaned = phone.replace(/\s/g, "");
    return /^\+380\d{9}$/.test(cleaned);
};
